import { Entity } from "@common/types/entity";
import { CreateAdpRunConnection } from "@components/adpRun/CreateAdpRunConnection";
import { CommandItem } from "@design-system/CommandItem/CommandItem";
import { InstitutionIcon } from "@design-system/InstitutionIcon/InstitutionIcon";
import { useConnectTarget } from "@hooks/useConnectTarget";
import { useTypedFlags } from "@hooks/useTypedFlags";

interface Props {
    defaultEntity?: Entity;
    onConnected: () => void;
}

export const AdpRunCommandItem = ({ defaultEntity, onConnected }: Props) => {
    const { adpRunIntegration: isAdpRunEnabled } = useTypedFlags();
    const { isOrgConnect } = useConnectTarget();

    if (!isAdpRunEnabled || isOrgConnect) {
        return null;
    }

    return (
        <CreateAdpRunConnection
            onCreated={onConnected}
            defaultEntity={defaultEntity}
        >
            {({ connecting, initializeConnection }) => (
                <CommandItem
                    onSelect={initializeConnection}
                    disabled={connecting}
                    keywords={["adp", "run", "payroll"]}
                >
                    <InstitutionIcon institution="adp" size="sm" /> ADP RUN
                </CommandItem>
            )}
        </CreateAdpRunConnection>
    );
};
